import { motion } from "framer-motion";
import { BadgeCheck } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/Reveal";

const chapters = [
  {
    n: "01",
    title: "The Benoni Blending Plant",
    body: "Auto City Lubricants (PTY) Ltd is a registered ® LOBP — a Lubricant Oil Blending Plant based in Lakefield, Benoni. We toll blend in bulk, right here in South Africa.",
  },
  {
    n: "02",
    title: "100% Virgin Spec Base Oils",
    body: "Using only 100% virgin spec base oils and OEM approved additives, every blend follows API and ACEA standards that meet or exceed OEM approvals.",
  },
  {
    n: "03",
    title: "15+ Years of Reliable Supply",
    body: "A trusted distributor for more than 15 years, supplying industrial, automotive, mining and agricultural lubricants at unbeatable prices — outstanding quality, always.",
  },
];

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="relative py-28 sm:py-36 bg-coal/40">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <SectionHeading
          eyebrow="About Us"
          title="SOUTH AFRICA'S FASTEST GROWING LOCALLY BLENDED OIL BRAND"
          align="left"
        />
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div className="space-y-10">
            {chapters.map((c, i) => (
              <Reveal key={c.n} delay={i * 0.12}>
                <div data-testid={`about-chapter-${c.n}`} className="flex gap-6 group">
                  <span className="font-heading font-black text-5xl sm:text-6xl leading-none text-outline-gold group-hover:text-gold transition-colors duration-500 shrink-0">
                    {c.n}
                  </span>
                  <div className="border-l border-gold/20 pl-6">
                    <h3 className="font-heading font-extrabold uppercase text-2xl text-white tracking-tight">
                      {c.title}
                    </h3>
                    <p className="mt-2 text-sm sm:text-base text-zinc-400 leading-relaxed">{c.body}</p>
                  </div>
                </div>
              </Reveal>
            ))}
            <Reveal delay={0.3}>
              <p className="font-heading italic font-bold text-2xl sm:text-3xl text-gold" data-testid="about-tagline">
                “When Performance Matters, We Deliver!”
              </p>
            </Reveal>
          </div>

          <Reveal delay={0.15}>
            <div className="relative" data-testid="about-image-frame">
              <div className="absolute -inset-5 bg-gold/10 blur-3xl rounded-full" />
              <motion.div
                whileHover={{ scale: 1.02 }}
                transition={{ duration: 0.5 }}
                className="relative rounded-2xl overflow-hidden border border-gold/25 shadow-[0_40px_80px_-20px_rgba(0,0,0,0.8)]"
              >
                <img
                  src="/assets/gen-plant.png"
                  alt="Auto City Lubricants blending plant and bulk lubricant supply"
                  className="w-full h-[32rem] object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-obsidian/70 via-transparent to-transparent" />
              </motion.div>
              <div className="absolute -bottom-6 left-6 right-6 sm:right-auto bg-obsidian/90 backdrop-blur-md border border-gold/30 rounded-xl px-6 py-4 flex items-center gap-3">
                <BadgeCheck size={26} className="text-gold shrink-0" strokeWidth={1.75} />
                <div>
                  <p className="font-heading font-extrabold uppercase text-white text-lg leading-none">
                    Registered ® LOBP
                  </p>
                  <p className="text-[10px] uppercase tracking-widest text-zinc-400 mt-1">
                    Lubricant Oil Blending Plant — Benoni
                  </p>
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
